import React, { useState } from 'react';
import { FormGroup, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faBan, faSave, faTrashAlt, faEnvelope, faCommentDots, faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import { getInputDate, addMinutesToDateTime } from '../../Helper';

function NewCommentCard(props) {
    const [feeComment, setFeeComment] = useState(props.feeComment);

    const updateComment = (e) => {
        console.log('Updating fee comment...');
        let value = e.target.value;
        switch (e.target.type) {
            case "number":
                value = e.target.valueAsNumber;
                break;
            case "date":
                value = new Date(e.target.value + 'T00:00');
                break;
        }
        setFeeComment({ ...feeComment, [e.target.name]: value });
    };

    const cancel = () => {
        props.cancel(feeComment.feeCommentID);
    };

    const save = () => {
        console.log('Saving fee comment...');
        props.save(feeComment);
    };

    const feeCommentJSX = (
        <div className="feeComment card  item-details">
            <div className="properties">
                <InputGroup className="comments">
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <FontAwesomeIcon icon={faCommentDots} />
                        </InputGroupText>
                    </InputGroupAddon>
                    <textarea placeholder="Comment" name="comment" value={feeComment.comment || ''} onChange={updateComment} />
                </InputGroup>
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <FontAwesomeIcon icon={faCalendarAlt} />
                        </InputGroupText>
                    </InputGroupAddon>
                    <Input type="date" placeholder="Comment Date" name="commentDate" value={getInputDate(feeComment.commentDate) || ''} onChange={updateComment} />
                </InputGroup>
            </div>
            <div className="actions-horizontal">
                <div onClick={cancel} className="action-icon action-delete">
                    <FontAwesomeIcon icon={faBan} />
                </div>
                <div onClick={save} className="action-icon action-add">
                    <FontAwesomeIcon icon={faSave} />
                </div>
            </div>
        </div>
    );

    return feeCommentJSX;
}

export default NewCommentCard;